import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';

type Props = {
    errorMessage: string;
};

export function EmailReplyModalErrorState(props: Props) {
    return (
        <div className='full-height full-width flex align-center justify-center'>
            <EmptyStateSmall
                title={props.errorMessage}
                subtitle={
                    <div className='flex'>
                        Please try again or&nbsp;
                        <Link href='https://www.nutshell.com/support' variant='primary'>
                            contact support.
                        </Link>
                    </div>
                }
                icon={
                    <div style={{width: '150px'}}>
                        <Illustration src='plug-error-state' width='100%' height='100%' />
                    </div>
                }
            />
        </div>
    );
}
